<template lang="pug">
.options
  .backdrop
  .content
    .title VVR Fahrkarte
    div(v-if="qrcode")
      div(v-html="qrcode")
    Loader(v-else)
    .current-time
      div {{ type }} - {{ validZones }}
      div {{ timeFrom }} - {{ timeUntil }}
      hr
      div {{ datetime[0] }}
      div {{ datetime[1] }}
    Button(color="gray" @click.native="close" center path="infoDialog.close.button").button
</template>

<script>
import { mapActions } from 'vuex';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import moment from 'moment';

export default {
  components: {
    Button,
    Loader,
  },
  props: ['overlaydata'],
  data() {
    return {
      datetime: [],
      qrcode: '',
      type: '',
      validZones: '',
      timeFrom: '',
      timeUntil: '',
    };
  },
  methods: {
    close() {
      this.$store.commit('openOverlay', '');
    },
    time() {
      this.datetime = [moment().format('DD.MM.YYYY'), moment().format('HH:mm:ss')];
    },
    ...mapActions(['publicTransportTicket']),
  },
  mounted() {
    this.time();
    this.interval = setInterval(this.time, 1000);
    this.publicTransportTicket()
      .then(data => {
        this.qrcode = data.qrcode;
        this.type = data.type;
        this.validZones = data.validZones;
        this.timeFrom = moment.unix(data.timeFrom).format('DD.MM.YYYY');
        this.timeUntil = moment.unix(data.timeUntil).format('DD.MM.YYYY');
      })
      .catch(error => {
        this.$store.commit('openOverlay', {
          overlayName: 'Info',
          overlayData: {
            title: 'Error',
            message: error.message,
          },
        });
      });
  },
};
</script>

<style lang="sass" scoped>
.options
  width: 100%
  height: 100vh
  display: flex
  flex-direction: column
  align-items: center
  justify-content: center
  position: fixed
  max-width: 480px
  margin: 0 auto
  right: 0
  top: 0
  left: 0
  z-index: 3000
.backdrop
  background-color: rgba(0, 0, 0, .8)
  width: 100%
  height: 100vh
  position: absolute
  z-index: 6
.content
  z-index: 7
  background-color: #fff
  border-radius: 10px
  padding: 20px
  margin: 20px
  position: relative
  width: calc(100% - 40px)
  max-height: 100vh
  overflow: auto
.title
  font-size: 25px
  color: #1DB2D1
  text-align: center
.message
  text-align: center
  color: #454F63
  margin-top: 20px
  padding-left: 20px
  line-break: anywhere
.qrcode
  margin-top: 10px
  width: 100%
  max-width: 100vw
  max-height: 100vh
.button
  margin-top: 20px
.current-time
  margin: 1rem 0 2rem
  text-align: center
  font-size: 1.5rem
</style>
